import { Tooltip } from "@material-ui/core";
import { useTranslation } from "react-i18next";

// Styles
import MaturityLevelStyle from "../../../../assets/styles/materialUI/questionnaire/assessmentResult/assessmentDashboard/MaturityLevelStyle";

// Providers
import { useLanguage } from "../../../../contexts/languageContext";

export default function MaturityLevel({ score }) {
	const { t } = useTranslation();
	const { direction } = useLanguage();

	const getColorFromScore = (score) => {
		if (score >= 0 && score <= 2) return "red";
		if (score > 2 && score <= 4) return "yellow";
		if (score > 4 && score <= 6) return "orange";
		if (score > 6 && score <= 8) return "lightgreen";
		if (score > 8 && score <= 10) return "darkgreen";
		return "gray";
	};
	const getTextColorFromScore = (score) => {
		if (score >= 0 && score <= 2) return "#fff";
		if (score > 2 && score <= 4) return "#000";
		if (score > 4 && score <= 6) return "#000";
		if (score > 6 && score <= 8) return "#000";
		if (score > 8 && score <= 10) return "#fff";
		return "gray";
	};

	const dynamicBGColor = getColorFromScore(score);
	const dynamicTextColor = getTextColorFromScore(score);
	const classes = MaturityLevelStyle({ color: dynamicBGColor, textColor: dynamicTextColor });

	const renderTooltipContent = () => {
		if (score >= 0 && score <= 2) {
			return <div className={classes.tooltip}>{t("maturity.tooltips.notStarted")}</div>;
		} else if (score > 2 && score <= 4) {
			return <div className={classes.tooltip}>{t("maturity.tooltips.developing")}</div>;
		} else if (score > 4 && score <= 6) {
			return <div className={classes.tooltip}>{t("maturity.tooltips.established")}</div>;
		} else if (score > 6 && score <= 8) {
			return <div className={classes.tooltip}>{t("maturity.tooltips.integrated")}</div>;
		} else if (score > 8 && score <= 10) {
			return <div className={classes.tooltip}>{t("maturity.tooltips.advanced")}</div>;
		} else {
			return <div className={classes.tooltip}>{t("maturity.tooltips.na")}</div>;
		}
	};

	const renderMaturityLevel = (score) => {
		if (score >= 0 && score <= 2) {
			return t("maturity.levels.notStarted");
		} else if (score > 2 && score <= 4) {
			return t("maturity.levels.developing");
		} else if (score > 4 && score <= 6) {
			return t("maturity.levels.established");
		} else if (score > 6 && score <= 8) {
			return t("maturity.levels.integrated");
		} else if (score > 8 && score <= 10) {
			return t("maturity.levels.advanced");
		} else {
			return t("maturity.levels.na");
		}
	};

	return (
		<Tooltip title={renderTooltipContent(score)} dir={direction}>
			<span className={classes.tooltipBackground}>{renderMaturityLevel(score)}</span>
		</Tooltip>
	);
}
